import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Card } from '../../../components/ui/card';
import BackButton from '../../../components/admin/BackButton';

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const invoiceId = searchParams.get('invoice_id');

  const handleTryAgain = () => {
    if (invoiceId) {
      navigate(`/admin/finance/invoices/${invoiceId}`);
    } else {
      navigate('/admin/finance/invoices');
    }
  };

  const handleBackToInvoices = () => {
    navigate('/admin/finance/invoices');
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <BackButton />

      <div className="max-w-2xl mx-auto mt-16">
        <Card className="p-8 text-center">
          <XCircle className="w-16 h-16 mx-auto mb-4 text-yellow-500" />
          
          <h1 className="text-2xl font-bold text-[#2B2D42] mb-2">
            Payment Cancelled
          </h1>
          
          <p className="text-gray-600 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>

          <div className="flex gap-3 justify-center">
            <Button
              onClick={handleTryAgain}
              className="bg-[#00B4D8] hover:bg-[#023E8A] text-white"
            >
              Try Again
            </Button>
            <Button
              variant="outline"
              onClick={handleBackToInvoices}
            >
              Back to Invoices
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;
